import React from "react";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { icons } from "../../../svg";

const RailRateRequestFailedPopup: React.FC = () => {
  const [showRailRateRequestFailedPopup, setShowRailRateRequestFailedPopup] =
    useNitroCAStore((state) => [
      state.showRailRateRequestFailedPopup,
      state.setShowRailRateRequestFailedPopup,
    ]);

  if (!showRailRateRequestFailedPopup) return null;

  return (
    <div
      className={styles.railRateRequestFailedPopupShell}
      role="alertdialog"
      aria-labelledby="rail-rate-request-failed-title"
      aria-describedby="rail-rate-request-failed-description"
    >
      <div className={styles.railRateRequestFailedCard}>
        <button
          type="button"
          aria-label="Close rail rate request failed popup"
          className={styles.railRateRequestFailedCloseButton}
          onClick={() => setShowRailRateRequestFailedPopup(false)}
        >
          ✕
        </button>
        <img
          data-tooltip-id="exclamation-mark-with-circle"
          src={icons.ExclamationMarkWithCircle}
          alt="exclamation-mark-with-circle"
          className={styles.railRateRequestFailedIcon}
        />
        <div className={styles.railRateRequestFailedCopy}>
          <span
            id="rail-rate-request-failed-title"
            className={styles.railRateRequestFailedTitle}
          >
            Rail Rate Request Failed to Send
          </span>
          <span
            id="rail-rate-request-failed-description"
            className={styles.railRateRequestFailedDescription}
          >
            Try Again Later
          </span>
        </div>
      </div>
    </div>
  );
};

export default RailRateRequestFailedPopup;